import React, { useState, useEffect } from 'react';

const useFullscreenStatus = (): boolean => {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  useEffect(() => {
    document.onfullscreenchange = () => {
      if (document.fullscreenElement) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };
    return () => {
      document.onfullscreenchange = null;
    };
  }, []);

  return isFullscreen;
};

export default useFullscreenStatus;
